import PeriprocedureelBeleidDabigatran from "../../../../src/client/lta-antistolling/periprocedureel-beleid-dabigatran.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidDabigatran,
  ChartCollapse,
  React
};